import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import clsx from 'clsx';

export default function LeftInfoPricingSection() {
  const { t: tt } = useTranslation('plans');

  return (
    <div className="flex flex-col items-center gap-[16px]">
      <h1
        className={clsx(
          'm-0',
          'text-[24px] leading-tight tracking-tighter',
          'text-center text-white/60 font-normal',
        )}
      >
        {tt('crypto.title-left')}
      </h1>

      <img
        src="/crypto/kaguya.webp"
        width={200}
        height={200}
        alt="crypto banner with ai girl"
      />
    </div>
  );
}
